<app-shared-trained-list
    [departmentType]="departmentType"
    [registerType]="registerType"
></app-shared-trained-list>
